/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_Consent_Cancellation_LinkInputs */

const en_checkout_consent_cancellation_link = /** @type {(inputs: Checkout_Consent_Cancellation_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellation Policy`)
};

/**
* | output |
* | --- |
* | "Cancellation Policy" |
*
* @param {Checkout_Consent_Cancellation_LinkInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const checkout_consent_cancellation_link = /** @type {((inputs?: Checkout_Consent_Cancellation_LinkInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_Consent_Cancellation_LinkInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_checkout_consent_cancellation_link(inputs)
});